export default __webpack_public_path__ + "static/media/copy-icon.5b166b45.svg";